import './App.css';
import { usePageAnalytics } from './analytics/pageAnalytics';
import Hero from './components/layout/Hero';
import CarCultureSection from './components/layout/CarCultureSection';
import LeaderboardSection from './components/layout/LeaderboardSection';
import VendorSection from './components/layout/VendorSection';
import DriveBySection from './components/layout/DriveBySection';
import FAQsSection from './components/layout/FAQsSection';
import Footer from './components/layout/Footer';
//import VendorShopSection from './components/layout/VendorShopSection';

function App() {
  usePageAnalytics();

  return (
    <div className="App w-full min-h-screen bg-[#0B0B0B] overflow-x-hidden">
      <Hero />
      <CarCultureSection />
      <LeaderboardSection />
      <VendorSection />
      <DriveBySection />
      <FAQsSection />
      {/* <VendorShopSection /> */}
      <Footer />
    </div>
  );
}

export default App;


